@if ((loading$ | async) === true) {
  <div class="oph-loading-container">
    <oph-loading></oph-loading>
  </div>
} @else if ((noProjects$ | async) && (loading$ | async) === false) {
  <create-first type="project" (buttonClick)="onOpenProjectDialog()"></create-first>
} @else {
  <div class="projects-content-container">
    <div
      class="projects-outlet-wrap"
      [@swipe]="viewIndex | async"
      (@swipe.start)="onSwipeStart()"
      (@swipe.done)="onSwipeDone()"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
}
